// removed by extract-text-webpack-plugin
module.exports = {"cont":"TourWork__cont___38-LM","main":"TourWork__main___2AvV6","heroSwapper":"TourWork__heroSwapper___F2A8b","hero":"TourWork__hero___3rzSY","heroTitle":"TourWork__heroTitle___nisFQ","heroYear":"TourWork__heroYear___1jTbI","heroRoomNumber":"TourWork__heroRoomNumber___ksDFw","body":"TourWork__body___1cCcJ","content":"TourWork__content___2lGSw","mapButton":"TourWork__mapButton___N302i"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/TourWork/TourWork.css
// module id = 761
// module chunks = 0